<div class="content-div">
  <app-biq-progress-bar 
    [questNo]="questNo"
    [totalQuestions]="totalQuestions"
  ></app-biq-progress-bar>

  <div class="form-div">
    <p class="heading">What city are you hoping to work in after graduation?</p>
    <p class="sub-heading">Sharing your preferred city helps us personalize career info. We’re starting with U.S. cities but plan to expand soon. </p>
    <div class="location-container">
      <mat-form-field appearance="fill" class="full-width rounded-input black-caret"
        [class.valid-input]="locationControl.valid && selectedLocation"
        [class.invalid-input]="locationControl.invalid && locationControl.touched && availableOptions.length === 0"
        [class.has-suggestions]="availableOptions.length > 0"
      >
        <input
          type="text"
          matInput
          [formControl]="locationControl"
          [matAutocomplete]="auto"
          [attr.aria-busy]="isFetchingLocations"
          required
        />
        <mat-autocomplete #auto="matAutocomplete" class="separated-dropdown-options" (optionSelected)="onLocationSelected($event)">
          @for (option of filteredLocations | async; track $index) {
            <mat-option [value]="option">
              {{ option.description || option }}
            </mat-option>
          }
        </mat-autocomplete>

        @if (locationControl.hasError('required') && (
          locationControl.touched || locationControl.dirty)
        ) {
          <mat-error class="input-error">
            Location is required
          </mat-error>
        }

        @if (locationControl.hasError('invalidLocation') && locationControl.touched) {
          <mat-error class="input-error">
            Invalid location
          </mat-error>
        }
      </mat-form-field>
    </div>
    <app-biq-button 
      (buttonEmitter)="onClickContinue()"
      [loader]="isLoading"
    ></app-biq-button>
  </div>
</div>